import { Component, OnInit, Input } from '@angular/core';
import { MUser } from '@argalis-apps/models';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'ags-extranet-header',
  templateUrl: './extranet-header.component.html',
  styleUrls: ['./extranet-header.component.scss']
})
export class ExtranetHeaderComponent implements OnInit {
  constructor() {}

  @Input() userConnected: MUser.CUser;
  @Input() signout: Observable<Object>;
  @Input() userChange: Subject<MUser.CUser>;
  @Input() themingClassName: string;

  ngOnInit() {}
}
